export default function () {
    let bodyElement = document.getElementsByTagName('body')[0]
    let headerHamburger = document.getElementsByClassName('header__hamburger')[0]
    let closeButton = document.getElementsByClassName('header__menu__close-button')[0]
    let navigationCollapse = document.getElementsByClassName('header__menu__navigation')[0]
    let collapsableSubMenuItems = document.getElementsByClassName('has-menu')

    headerHamburger.addEventListener('click', function () {
        bodyElement.classList.toggle('no-scroll')
        headerHamburger.classList.toggle('hide')
        closeButton.classList.toggle('show')
        navigationCollapse.classList.toggle('show')
    })

    closeButton.addEventListener('click', function () {
        bodyElement.classList.toggle('no-scroll')
        headerHamburger.classList.toggle('hide')
        closeButton.classList.toggle('show')
        navigationCollapse.classList.toggle('show')
    })

    for (let i = 0; i < collapsableSubMenuItems.length; i++) {
        collapsableSubMenuItems[i].addEventListener('click', function (e) {
            if (e.target.tagName === 'SPAN') {
                e.target.classList.toggle('collapse')
                e.target.nextElementSibling.classList.toggle('collapse')
            }
        })
    }
}
